import { render } from "./OrientationCriteria.vue?vue&type=template&id=4d9af41f"
import script from "./OrientationCriteria.vue?vue&type=script&lang=js"
export * from "./OrientationCriteria.vue?vue&type=script&lang=js"

import "./OrientationCriteria.vue?vue&type=style&index=0&id=4d9af41f&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__